import { dashboardKnowledgePageRequest } from "../../../actions/dashboard-actions"

import buildListContainer from "../../common/build-list-container"
import DashboardKnowledgeListItem from "./DashboardKnowledgeListItem"
import KnowledgeListItemShadow from "../../common/knowledge-list/KnowledgeListItemShadow"

export default buildListContainer(
    DashboardKnowledgeListItem,
    KnowledgeListItemShadow,
    dashboardKnowledgePageRequest,
    null,
    "dashboard",
    "moderationFeed",
    "knowledge"
)
